import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Droplets, Copy, Video } from 'lucide-react';
const benefits = [{
  icon: <BookOpen className="w-6 h-6 text-[#00d4ff]" data-id="element-169" />,
  title: 'Guía de Identidad Estable',
  description: 'El paso a paso exacto para configurar tu entorno y asegurar que la cara de tu modelo nunca mute entre generaciones.'
}, {
  icon: <Droplets className="w-6 h-6 text-[#00d4ff]" data-id="element-170" />,
  title: 'Arquitectura de Piel y Textura',
  description: "Técnicas avanzadas para eliminar el 'brillo artificial' de la IA y lograr poros, imperfecciones y texturas 100% humanas."
}, {
  icon: <Copy className="w-6 h-6 text-[#00d4ff]" data-id="element-171" />,
  title: 'Proceso de Generación Masiva',
  description: 'El flujo de trabajo optimizado para sacar 50 fotos coherentes y de alta calidad en menos de 20 minutos.'
}, {
  icon: <Video className="w-6 h-6 text-[#00d4ff]" data-id="element-172" />,
  title: 'Optimización para Animación',
  description: 'Prepara el rostro estructuralmente para que al pasarlo por herramientas de video no se deforme ni pierda realismo.'
}];
export function OfferSection() {
  return <section className="py-24 px-5 relative bg-[#050508] border-y border-white/5" data-id="element-173">
      <div className="max-w-6xl mx-auto" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-176">
            Dentro del{' '}
            <span className="text-white" data-id="element-177">Método Operativo Definitivo</span>{' '}
            encontrarás:
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-178">
            Todo lo que necesitas en un formato PDF directo al grano, sin
            relleno.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-179">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-card p-8 rounded-2xl hover:bg-white/[0.03] transition-colors group" data-id="element-180">
              <div className="w-12 h-12 rounded-xl bg-[#00d4ff]/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-181">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-182">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-183">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}